import { render, staticRenderFns } from "./pbj.vue?vue&type=template&id=12f44474&scoped=true&"
import script from "./pbj.vue?vue&type=script&lang=js&"
export * from "./pbj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f44474",
  null
  
)

export default component.exports